<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-fussion" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div class="container">
    <div class="common signupformsection">				
        <div class="signupform">
            <div class="logodiv text-center">
              <a href="#" routerLink="/dashboard"><img src="assets/images/logo.png"></a>
            </div>
            <div class="common signuphdng">
                <h6 class="formheading_sgnup">Sign Up</h6>
                <p class="privcttxt mr-bttm-5{">Get started with a free account</p>
            </div>
            <form (submit)="signupUser($event)" >
                <div class="form-group">						  
                  <input type="text" class="form-control" id="fname" placeholder="Enter first name" name="name">
                </div>
                <div class="form-group">						  
                    <input type="text" class="form-control" id="lname" placeholder="Enter last name" name="name">
                  </div>
                <div class="form-group">						  
                  <input type="email" class="form-control" id="email" placeholder="Enter email" name="new_email">
                  <span class="inputValidation">{{ emailError }}</span>
                </div>
                <div class="form-group">						  
                  <input type="password" class="form-control" id="password" placeholder="Enter password" name="enter_password" (keyup) = "enterPassword($event.target.value)">
                  <span class="inputValidation">{{ passwordError }}</span>
                  <span class="inputValidation">{{ validPasswordMsg }}</span>
                </div>
                <div class="form-group">						  
                  <input type="password" class="form-control" id="cnfrm_password" placeholder="Confirm password" name="cnfrm_password">
                  <span class="inputValidation">{{ confirmPasswordError }}</span>
                </div>
                <div class="form-group text-center">
                    <input type="submit" class="sgninbtn" name="sgninbtn" value="Sign Up" [disabled] = "validPassword ? false : true">
                </div>
                <span class="successMessage">{{ signupSuccess }}</span>
            </form>
            <div class=" privcttxt_div mr-top-0">
                <p class="privcttxt">By clicking Sign In, you agree to our <a href="javascript:void(0)"  routerLink="/terms" target="_blank">Terms</a> and have read and acknowledge our <a href="javascript:void(0)" routerLink="/privacy" target="_blank">US Privacy Statement.</a></p>
            </div>
            <div class="signuptextdiv">
                <p class="privcttxt text-center">Already a member? <a routerLink="/login">Sign in</a> </p>
            </div>
        </div>
    </div>
</div>